import { toSentenceCase, updateCategoryType } from '@/plugins/dataLayer/utils/index.js';

export default function($store) {
  return {
    name: {
      ugc: 'UGC Flow',
      imageLibrary: 'UGC Flow - Image Library',
      checkerboarder: 'UGC Flow - Checkerboarder',
      holidaytool: 'holidaytool',
      transferDesign: 'Customizer - Change Style - UGC Flow'
    },
    event: {
      name: 'trackEvent',
      nameIframe: 'loadEventData',
      category: 'Customs',
      customMetrics: {},
      customVariables: {},
      _clear: true,
      nonInteractive: false
    },
    types: {
      applyEdits: 'apply edits and position',
      backModal: 'Back Modal',
      chooseImage: 'choose image',
      clickUgctool: ' - Edit and Position',
      closeIntroVideo: 'UGC Flow - Video - Style Selection',
      complete: 'Finish',
      confirmDesign: 'confirm design',
      continue: 'Continue',
      continueSamePhoto: 'Continue Same Photo',
      customPattern: 'custom checkerboard',
      designLoaded: 'Confirmed Design Loaded',
      entryPoint: 'External Entry Point',
      finish: 'Finish',
      finishAlmostDone: 'Finish',
      imageLoaded: 'Set Placement ',
      libraryNext: 'Next: ',
      introVideo: 'UGC Flow - Video - Top Nav',
      next: 'next',
      toggleCategory: 'See ',
      selectImage: 'Image Choose: ',
      selectSize: 'Select Size ',
      steps: 'step',
      termsConditionsNext: 'Terms and Conditions - Next',
      ugc: 'ugc',
      uploadAccepted: 'Image Upload Accepted',
      uploadAnotherPhoto: 'upload another photo',
      uploadAnotherPhotoEcom: 'Upload Another Photo',
      uploadAPhoto: 'upload a photo',
      uploadError: 'Image Upload Rejected',
      continueToCustomize: 'Choose Size – Continue to Customize',
      editAndPosition: 'Edit & Position Image'
    },
    /**
     * @function logAnalyticsEvent
     * @description Adds an event to GTM's dataLayer.
     * These events are during the ugc workflow
     * but share the same formatting. This function is provided for the UGC
     * in order to avoid code duplication in the formatting of the GTM events.
     *
     * @param {object} payload
     * MUST have type attribute, to assure the dataLayer event type.
     * MUST have eventLabel attribute for next event, to assure the dataLayer eventLabel.
     * @returns {void}
     */
    logAnalyticsEvent: function (payload) {
      let validEvent = true;

      const useEcomDataLayerFormat = $store.getters['utils/useEcomDataLayerFormat'];
      const canvasActive = $store.getters["utils/canvasActive"];
      const data = {
        event: useEcomDataLayerFormat ? this.event.nameIframe : this.event.name,
        eventCategory: this.event.category,
        eventAction: this.name[payload.action]
      };

      if (useEcomDataLayerFormat) {
        data.nonInteractive = this.event.nonInteractive;
        data.customMetrics = payload.customMetrics ? payload.customMetrics : this.event.customMetrics;
        data.customVariables = payload.customMetrics ? payload.customMetrics : this.event.customVariables;
        data._clear = this.event._clear;
      }

      if (payload.type ===  this.types.introVideo) {
        data.eventLabel = payload.eventLabel;
        data.eventAction = this.types.introVideo;
      } else if (payload.type ===  this.types.closeIntroVideo) {
        data.eventLabel = payload.eventLabel;
        data.eventAction = this.types.closeIntroVideo;
      }

      if (typeof payload.eventLabel !== 'undefined') {
        data.eventLabel = payload.eventLabel;
      } else if (typeof payload.type !== 'undefined') {
        data.eventLabel = this.types[payload.type] || payload.type;
        if (payload.type === this.types.applyEdits || payload.type === this.types.confirmDesign) {
          data.silhouette = `${ payload.style }`;
        }
        if(payload.type === this.types.steps){
          data.eventLabel = `step ${($store.state.ugc.stateManager.currentUgcView + 1) }`;
        }

      } else {
        validEvent = false;
      }

      if (typeof payload.type !== 'undefined' && payload.type === this.types.entryPoint) {
        data.eventAction = payload.action + ' - Video - External Entry Point';
      }

      if (typeof payload.type !== 'undefined' && payload.type === this.types.clickUgctool) {
        data.eventAction = this.name[payload.action] + this.types.clickUgctool;
		    data.eventLabel = toSentenceCase(payload.eventLabel);
      }

      if (typeof payload.type !== 'undefined' && payload.type === this.types.imageLoaded) {
        data.eventLabel = data.eventLabel + payload.step;
      }

      if (typeof payload.type !== 'undefined' && payload.type === this.types.selectImage) {
        data.eventLabel = `${this.types.selectImage}${toSentenceCase(payload.eventLabel)} - id_${payload.image}`;
      }

      if (typeof payload.type !== 'undefined' && payload.type === this.types.selectSize) {
        data.eventAction = `${this.name[payload.action]} - ${this.types.selectSize}`;
        data.eventLabel = `${toSentenceCase(payload.eventLabel)}, ${payload.size}`;
      }

      if (typeof payload.type !== 'undefined' && payload.type === this.types.toggleCategory) {
        data.eventLabel = `${this.types.toggleCategory}${payload.eventLabel}: ${toSentenceCase(payload.category)}`;
      }

      if (typeof payload.type !== 'undefined' && payload.type === this.types.libraryNext) {
        data.eventLabel = `${this.types.libraryNext}${toSentenceCase(payload.eventLabel)} - id_${payload.image}`;
      }

      if (validEvent) {
        try {
          if(canvasActive) parent.dataLayer.push(data);
          else dataLayer.push(data)
        } catch (err) {
          console.error("CORS origin error on datalayer push to parent", err);
        }
      } else {
        console.warn('UGC: invalid data layer event: ', data);
      }
    },
    updateCategoryType: updateCategoryType,
  };
};
